import { FormEvent, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { ApiError } from '../api/client';
import { useAuth } from '../auth/useAuth';
import { errorMessage, ptBR } from '../i18n/pt-BR';

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/" replace />;

  async function handleSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(errorMessage(err instanceof ApiError ? err.code : undefined));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main
      style={{
        fontFamily: 'system-ui, sans-serif',
        maxWidth: 360,
        margin: '6rem auto',
        padding: '0 1rem',
      }}
    >
      <h1 style={{ marginBottom: 4 }}>{ptBR.appName}</h1>
      <p style={{ color: '#666', marginTop: 0 }}>{ptBR.tagline}</p>

      <form
        onSubmit={handleSubmit}
        style={{
          marginTop: 32,
          padding: 16,
          border: '1px solid #ddd',
          borderRadius: 8,
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
        }}
      >
        <h2 style={{ margin: 0, fontSize: 18 }}>{ptBR.auth.loginTitle}</h2>
        <label>
          {ptBR.auth.email}
          <br />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: '100%' }}
          />
        </label>
        <label>
          {ptBR.auth.password}
          <br />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: '100%' }}
          />
        </label>
        {error && <p style={{ color: '#c5221f', margin: 0 }}>{error}</p>}
        <button type="submit" disabled={submitting}>
          {ptBR.auth.submit}
        </button>
      </form>
    </main>
  );
}
